export const DureeOptions = [
    {
        key: "empty",
        text: "",
        value: ""
    },
    { key: "2 jours", text: "2 jours", value: "2 jours" },
    { key: "3 jours", text: "3 jours", value: "3 jours" },
    { key: "5 jours", text: "5 jours", value: "5 jours" },
    { key: "1 semaine", text: "1 semaine", value: "1 semaine" },
    { key: "10 jours", text: "10 jours", value: "10 jours" },
    { key: "2 semaines", text: "2 semaines", value: "2 semaines" },
    { key: "3 semaines", text: "3 semaines", value: "3 semaines" },
    { key: "1 mois", text: "1 mois", value: "1 mois" },
    { key: "2 mois", text: "2 mois", value: "2 mois" },
    { key: "3 mois", text: "3 mois", value: "3 mois" },
    { key: "6 mois", text: "6 mois", value: "6 mois" },
    { key: "1 an", text: "1 an", value: "1 an" },
];